module.exports = __webpack_public_path__ + "img/coffee.881d411e.svg";